import { createTheme } from "@mui/material/styles";
import { theme } from "./dark";

export const appTheme = createTheme(theme);
